module.exports = __webpack_public_path__ + "static/media/police.d0289dc0.png";